import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import UserService from "../services/UserService";
import { useNavigate } from "react-router-dom";

const theme = createTheme();

export default function SignIn(props: { isRegistering?: boolean; isLogout?: boolean }) {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [teamName, setTeamName] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string | undefined>();
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [showLoginError, setShowLoginError] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (props.isLogout) {
      UserService.logout();
    }
  }, [props.isLogout]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowLoginError(false);
    //TODO:DF spinner
    if (props.isRegistering) {
      if (password !== confirmPassword) {
        setPasswordError("Passwords do not match");
        return;
      }
      const result = await UserService.register(username, password, name, teamName);
      if (!result) {
        setPassword("");
      } else {
        const result = await UserService.login(username, password, rememberMe);
        if (!result) {
          navigate("/login");
        }
      }
    } else {
      const result = await UserService.login(username, password, rememberMe);
      if (!result) {
        //TODO:DF show error
        setShowLoginError(true);
        return;
      }
    }
    navigate("/");
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, minWidth: 250 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {!props.isRegistering && showLoginError && <div className="error-message">Login Failed.</div>}
            {props.isRegistering && (
              <>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  autoComplete="current-password"
                  value={confirmPassword}
                  error={!!passwordError}
                  helperText={passwordError}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="name"
                  label="Your Name"
                  name="name"
                  autoComplete="name"
                  autoFocus
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="teamName"
                  label="Team Name"
                  name="teamName"
                  autoComplete="teamName"
                  autoFocus
                  value={teamName}
                  onChange={(e) => setTeamName(e.target.value)}
                />
              </>
            )}
            {!props.isRegistering && (
              <FormControlLabel
                control={<Checkbox value="remember" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} color="primary" />}
                label="Remember me"
              />
            )}
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              {props.isRegistering ? "Register" : "Sign In"}
            </Button>
            <Grid container>
              <Grid item xs>
                {!props.isRegistering && (
                  <Link href="/forgot-password" variant="body2">
                    Forgot password?
                  </Link>
                )}
              </Grid>
              <Grid item>
                {!props.isRegistering && (
                  <Link href="/register" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                )}
                {props.isRegistering && (
                  <Link href="/login" variant="body2">
                    {"Already have an account? Login"}
                  </Link>
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
